import { put, call, takeEvery } from 'redux-saga/effects'
// import { delay } from 'redux-saga'
import { startSubmit, stopSubmit } from 'redux-form'

import rootRoumu from './roumu'
import * as commons from '../commons'
import * as actions from '../actions'
import * as types from '../constants/ActionTypes'

import * as kenmeiList from './kenmeiList'
import * as kenmei from './kenmei'

import * as commonActions from '../actions/common'

//##### master
import * as master from './master'
import * as auth from './auth'
//##### master

//##### yosan
import * as yosan from './yosan'
//##### yosan

//##### yosan
import * as yosanList from './yosanList'
//##### yosan

//##### bizHoliday
import * as bizHoliday from './bizHoliday'
//##### bizHoliday

//##### bizHoliday
import * as subHoliday from './subHoliday'
//##### bizHoliday

//##### bizHoliday
import * as systemControll from './systemControll'
//##### bizHoliday


function* handleFetchKenmeiCodes(action) {


  const kenmeiCodes = yield call(commons.getKenmei)


  yield put(commonActions.reducerSetKenmeiCodes(kenmeiCodes.result))

}

function* rootSaga() {

  yield takeEvery(types.USER_LOGIN , auth.handleLogin);
  yield takeEvery(types.USER_LOGOUT , auth.handleLogout);
  yield takeEvery(types.SYSTEM_FETCH_LOGIN_STATE , auth.handleFetchLoginState);
  yield takeEvery(commonActions.SYSTEM_FETCH_KENMEI_CODES , handleFetchKenmeiCodes);

  //##### master
  yield takeEvery(types.SYSTEM_MASTER_INIT , master.handleMasterInit);
  yield takeEvery(types.USER_MASTER_GET_LIST , master.handleMasterGetList);
  yield takeEvery(types.USER_MASTER_FORM_REGIST , master.handleMasterFormRegist);
  yield takeEvery(types.USER_MASTER_FORM_EDIT , master.handleMasterFormEdit);
  yield takeEvery(types.USER_MASTER_FORM_DELETE , master.handleMasterFormDelete);
  yield takeEvery(types.USER_MASTER_SEARCH , master.handleMasterSearch);
  //##### master

  //##### yosan
  yield takeEvery(types.SYSTEM_YOSAN_INIT , yosan.handleYosanInit);
  yield takeEvery(types.SYSTEM_YOSAN_HISTORY_INIT , yosan.handleYosanHistoryInit);
  yield takeEvery(types.USER_YOSAN_FORM_REGIST , yosan.handleYosanFormRegist);
  yield takeEvery(types.USER_YOSAN_FORM_DELETE , yosan.handleYosanFormDelete);
  //##### yosan

  //##### yosan
  yield takeEvery(types.SYSTEM_YOSANLIST_INIT , yosanList.handleYosanListInit);
  yield takeEvery(types.SYSTEM_YOSANHISTORYLIST_INIT , yosanList.handleYosanHistoryListInit);
  yield takeEvery(types.USER_YOSANLIST_SEARCH , yosanList.handleYosanListSearch);
  yield takeEvery(types.USER_YOSANHISTORYLIST_SEARCH , yosanList.handleYosanHistoryListSearch);
  yield takeEvery(types.USER_YOSANLIST_UPLOAD , yosanList.handleYosanListUpload);
  //##### yosan

  //##### bizHoliday
  yield takeEvery(types.SYSTEM_BIZ_HOLIDAY_INIT , bizHoliday.handleInit);
  yield takeEvery(types.USER_BIZ_HOLIDAY_REGIST , bizHoliday.handleRegist);
  yield takeEvery(types.USER_BIZ_HOLIDAY_CHANGE_YEAR , bizHoliday.handleChangeYear);
  //##### bizHoliday

  //##### subHoliday
  yield takeEvery(types.SYSTEM_SUB_HOLIDAY_INIT , subHoliday.handleInit);
  yield takeEvery(types.USER_SUB_HOLIDAY_REGIST , subHoliday.handleRegist);
  //##### subHoliday

  //##### systemControll
  yield takeEvery(types.USER_SYSTEM_CONTROLL_SUB_HOLIDAY_CLEAR , systemControll.handleSubHolidayClear);
  yield takeEvery(types.SYSTEM_SYSTEMCONTROLL_ROUMU_INIT , systemControll.handleSystemControllRoumuInit);
  //##### systemControll

  yield rootRoumu()


}

export default rootSaga


// WEBPACK FOOTER //
// ./src/sagas/index.js